import { Alert, Box } from '@mui/material';
import QcPageLayout from '../components/QcPageLayout';
import QcTaskWorkflowBatchFilters from '../my-task/mt-qc-task-001/components/QcTaskWorkflowBatchFilters';
import QcTaskAssignmentsSummary from '../my-task/mt-qc-task-001/components/QcTaskAssignmentsSummary';
import { useAnnotSegPageController, AnnotSegTable } from './annot-seg-001';

function getWorkflowOptionLabel(option) {
  return `${option?.name ?? option?.workflow_id ?? ''} (${option?.workflow_type ?? ''})`;
}

export default function AnnotationSegmentationPage() {
  const {
    activeTab,
    workflowId,
    batchId,
    workflowValue,
    batchValue,
    workflowOptions,
    batchOptions,
    handleTabChange,
    handleWorkflowChange,
    handleBatchChange,
    isWorkflowLoading,
    isWorkflowFetching,
    isBatchesLoading,
    isBatchesFetching,
    isAnnotation,
    tagOptions,
    rows,
    rowCount,
    tableLoading,
    tableFilters,
    applyTableFiltersToUrl,
    pagination,
    setPagination,
    refetchAssignments,
    pageSizeOptions,
    defaultPageSize,
    errorMessage,
    sorting,
    onSortingChange,
  } = useAnnotSegPageController();

  return (
    <QcPageLayout
      title="Annotation & Segmentation"
      metaDescription="Audio annotation and segmentation tasks."
      breadcrumbTitle="Annotation &amp; Segmentation"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 0.5, sm: 1, md: 1.5, lg: 2, xl: 2.5 },
          pb: { xs: 'max(4px, env(safe-area-inset-bottom, 0px))', sm: 0 },
        }}
      >
        <QcTaskWorkflowBatchFilters
          activeTab={activeTab}
          workflowId={workflowId}
          workflowValue={workflowValue}
          batchValue={batchValue}
          workflowOptions={workflowOptions}
          batchOptions={batchOptions}
          isWorkflowLoading={isWorkflowLoading}
          isWorkflowFetching={isWorkflowFetching}
          isBatchesLoading={isBatchesLoading}
          isBatchesFetching={isBatchesFetching}
          onWorkflowChange={handleWorkflowChange}
          onBatchChange={handleBatchChange}
          getWorkflowOptionLabel={getWorkflowOptionLabel}
        />

        {errorMessage ? (
          <Alert
            severity="error"
            sx={{
              py: { xs: 0.35, sm: 0.75 },
              px: { xs: 1, sm: 1.5 },
              fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
              '& .MuiAlert-icon': { fontSize: { xs: '1.1rem', sm: '1.25rem' } },
            }}
          >
            {errorMessage}
          </Alert>
        ) : null}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 0, sm: 0.125, md: 0.25 } }}>
          <QcTaskAssignmentsSummary
            rowsLength={rows.length}
            rowCount={rowCount}
            loading={tableLoading}
          />

          <AnnotSegTable
            key={`annot-seg-table-${activeTab}-${workflowId}-${batchId}`}
            data={rows}
            rowCount={rowCount}
            isLoading={tableLoading}
            activeTab={activeTab}
            onTabChange={handleTabChange}
            pagination={pagination}
            onPaginationChange={setPagination}
            onRefreshTable={refetchAssignments}
            pageSizeOptions={pageSizeOptions}
            defaultPageSize={defaultPageSize}
            tableFilters={tableFilters}
            onTableFiltersChange={applyTableFiltersToUrl}
            sorting={sorting}
            onSortingChange={onSortingChange}
            isAnnotation={isAnnotation}
            tagOptions={tagOptions}
            workflowId={workflowId}
          />
        </Box>
      </Box>
    </QcPageLayout>
  );
}
